<app-font-family-loader [linkToCss]="viewModel.adobeFontFamilyCssUrl$ | async"></app-font-family-loader>

@for (data of viewModel.cardAsDataGroupedPerPage$ | async; track data) {
  @for (cardsAsData of data?.cardPages; track cardsAsData) {
    <app-page-of-cards [cardsAsData]="cardsAsData" [layoutInstructions]="data?.layoutInstructions" />
  }
}
